import "./recapSouscription.scss";
import {
  Button,
  Card,
  Emphasis,
} from "@lya-protect/lya-protect-form-library/dist/UI";
import { LoaderOverlay } from "@src/components/loaderOverlay/LoaderOverlay";
import { Stepbar } from "@src/components/stepbar/Stepbar";
import { MicroStep, StepProps } from "@src/Steps/step/Steps";
import { format } from "date-fns"; // eslint-disable-line import/no-duplicates
import fr from "date-fns/locale/fr"; // eslint-disable-line import/no-duplicates

export type RecapSouscriptionData = undefined;
type RecapSouscriptionProps = StepProps<RecapSouscriptionData>;

export function RecapSouscription({
  changeStep,
  projetSouscription,
}: RecapSouscriptionProps) {
  return (
    <>
      <LoaderOverlay isLoading={projetSouscription === undefined} />
      {projetSouscription !== undefined && (
        <div className="recap-souscription-step">
          <div className="stepper__centered-container ">
            <div className="recap-souscription-step__main stepper__centered-content step__grid step__grid--padding-bottom">
              <Stepbar activeMicroStep={MicroStep.PersonalInformation} />
              <h1>
                Votre souscription <Emphasis>en quelques clics !</Emphasis>
              </h1>
              <h3>Merci de vérifier que vos informations sont exactes :</h3>
              <div className="step__grid-bloc step__grid-bloc--small-margin-top recap-souscription-step__card-container">
                <Card
                  variant="accent"
                  className="recap-souscription-step__card-style"
                >
                  <div className="recap-souscription-step__header">
                    <h2>
                      <span className="recap-souscription-step__civility">
                        {projetSouscription.assure.civility}
                      </span>{" "}
                      {projetSouscription.assure.surname}{" "}
                      {projetSouscription.assure.name}
                    </h2>
                  </div>
                  <div className="recap-souscription-step__info-grid">
                    <div className="recap-souscription-step__info-item">
                      <p>Adresse mail</p>
                      <p>{projetSouscription.assure.mail}</p>
                    </div>
                    <div className="recap-souscription-step__info-item">
                      <p>Téléphone mobile</p>
                      <p>{projetSouscription.assure.mobile}</p>
                    </div>
                    <div className="recap-souscription-step__info-item">
                      <p>Adresse postale</p>
                      <p>
                        {projetSouscription.assure.address}
                        <br />
                        {projetSouscription.assure.zipcode}{" "}
                        {projetSouscription.assure.city}
                      </p>
                    </div>
                    {projetSouscription.assure.telephone && (
                      <div className="recap-souscription-step__info-item">
                        <p>Téléphone fixe</p>
                        <p>{projetSouscription.assure.telephone}</p>
                      </div>
                    )}
                    <div className="recap-souscription-step__info-item">
                      <p>Date de naissance</p>
                      <p>
                        {format(projetSouscription.assure.birthDate, "PPP", {
                          locale: fr,
                        })}
                      </p>
                    </div>
                  </div>
                </Card>
              </div>
              <Button onClick={() => changeStep("CONSENT", "forward")}>
                Suivant
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
